<script setup lang="ts">
  import ToastLayer from '@/components/Toasts/ToastLayer.vue';
  import useToasts from '@/components/Toasts/useToasts';
  import { DESKTOP_VIEWPORT_MIN_SCREEN_WIDTH } from '@/bootstrap/environment';
  import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
  import { VIEWPORT } from '@/constants';
  // eslint-disable-next-line
  type EventListener = EventListenerOrEventListenerObject;
  const { toastQueue, removeToast, hasToasts } = useToasts();
  const windowWidth = ref<number>(typeof window !== 'undefined' ? window.innerWidth : 0);
  const windowHeight = ref<number>(typeof window !== 'undefined' ? window.innerHeight : 0);
  const isLandScapedMode = ref<boolean>(false);

  const recompute = () => {
    if (typeof window === 'undefined') return;
    windowWidth.value = window.innerWidth;
    windowHeight.value = window.innerHeight;
    const angle = window?.screen?.orientation?.angle ?? 0;
    isLandScapedMode.value = (angle === 90 || angle === -90) && windowHeight.value < DESKTOP_VIEWPORT_MIN_SCREEN_WIDTH;
  };
  onMounted(() => {
    recompute();
    window.addEventListener('resize', recompute);
    window.screen?.orientation?.addEventListener?.('change', recompute as EventListener);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('resize', recompute);
    window.screen?.orientation?.removeEventListener?.('change', recompute as EventListener);
  });
  const getCurrentViewPort = computed(() =>
    windowWidth.value < DESKTOP_VIEWPORT_MIN_SCREEN_WIDTH ||
    isLandScapedMode.value ||
    windowWidth.value < windowHeight.value
      ? VIEWPORT.MOBILE
      : VIEWPORT.DESKTOP
  );
  const isMobileLayout = computed(() => getCurrentViewPort.value === VIEWPORT.MOBILE);
</script>

<template>
  <router-view />
  <toast-layer
    v-if="hasToasts"
    :toast-messages="toastQueue"
    @close-toast="removeToast"
    :is-mobile="isMobileLayout"
    :is-micro-frontend="false"
  />
</template>

<style scoped></style>
